import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CrudBasicDomains } from 'projects/phdsoft/common/src/lib/models/crud-basic-domains.model';

@Injectable({
  providedIn: 'root'
})
export class CrudBasicDomainsService {
  API = environment.API_ADMIN;
  readonly EndPoint = 'CrudBasicDomains';

  constructor(
    private http: HttpClient,
  ) {
    console.log('🔌 API', this.API);
  }

  getCrudBasicDomains(crudBasicDomains: CrudBasicDomains): Observable<CrudBasicDomains> {
    return this.http.get<CrudBasicDomains>(
      this.API + `${this.EndPoint}?pCrudId=${crudBasicDomains?.id}`);
  }

  getCrudBasicDomainsInspectionList(inspectionList: string[], assetId?: string): Observable<CrudBasicDomains> {
      return this.http.post<CrudBasicDomains>(
        this.API + `${this.EndPoint}/getinspectionlist`,
        inspectionList
      );
  }

  getCrudBasicDomainsInspectionListAll(): Observable<CrudBasicDomains> {
    return this.http.get<CrudBasicDomains>(
      this.API + `${this.EndPoint}/getinspectionlistall`
    );
  }

  addInspectionType(crudBasicDomains: CrudBasicDomains) {
    return this.http.post<CrudBasicDomains>(
      this.API + `${this.EndPoint}/addinspectiontype`,
      crudBasicDomains
    );
  }

  removeInspectionType(crudBasicDomains: CrudBasicDomains) {
    return this.http.delete(
      this.API + `${this.EndPoint}/removeinspectiontype?pInspecId=${crudBasicDomains?.id}`,
    );
  }

  updateInspectionType(crudBasicDomains: CrudBasicDomains) {
    return this.http.put(
      this.API + `${this.EndPoint}/updateinspectiontype`,
      crudBasicDomains
    );
  }

  getInspectionMethodList() {
    return this.http.get<CrudBasicDomains>(
      this.API + `${this.EndPoint}/getinspectionmethodlist`
    );
  }

  getInspectionCategoryList() {
    return this.http.get<CrudBasicDomains>(
      this.API + `${this.EndPoint}/inspection-categories`
    );
  }

}
